import { createFileRoute } from '@tanstack/react-router';

import { AdminClientDetailView } from 'src/sections/admin/client-detail/admin-client-detail-view';

export const Route = createFileRoute('/admin-skidog/$orgId/clients/$clientId')({
  component: AdminClientDetailPage,
});

function AdminClientDetailPage() {
  const { orgId, clientId } = Route.useParams();
  return <AdminClientDetailView organizationId={orgId} clientId={clientId} />;
}
